import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { GoogleOAuthProvider } from '@react-oauth/google'
import '@/index.css'
import App from './App'
import { ErrorBoundary } from './ErrorBoundary'

const GOOGLE_CLIENT_ID = '169152916876-1di566qm5batlv3n8005i1rm6drod539.apps.googleusercontent.com'

// Apply saved theme before first paint to avoid FOUC
try {
  const stored = localStorage.getItem('wl-theme')
  if (stored && JSON.parse(stored)?.state?.theme === 'dark') {
    document.documentElement.classList.add('dark')
  }
} catch {
  // ignore parse errors
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ErrorBoundary>
      <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </GoogleOAuthProvider>
    </ErrorBoundary>
  </React.StrictMode>
)
